/**
 * ATL-1966 — a Firestore-Timestamp-shaped value for a `Date`, as the typed API client builds one.
 *
 * A row read from the backend reaches the screens in the Firestore shape, and a screen that saves
 * it compares what it was seeded from against what it writes (`buildWriteBackDelta`, after
 * `sanitizeForFirestoreDeep`). The sanitizer recognises a Timestamp by `toDate()` PLUS `seconds` /
 * `nanoseconds`; a bare `{toDate}` is not one, so it sanitises to `{}` — and a seeded date of `{}`
 * differs from every date, which made each save of a Supabase-read supply order rewrite its date.
 * OperationsList built exactly that bare object. This is the shape `deserializeDates`
 * (packages/api-client `toTimestampLike`) produces, so both paths hand the screens the same value.
 */
export interface DateTimestampLike {
  toDate: () => Date
  seconds: number
  nanoseconds: number
}

export const timestampLikeOf = (date: Date): DateTimestampLike => ({
  toDate: () => date,
  seconds: Math.floor(date.getTime() / 1000),
  nanoseconds: (date.getTime() % 1000) * 1000000,
})
